import { Injectable } from "@angular/core";
import { EmailComposer } from "@ionic-native/email-composer";
import { BaseRequest } from "./base-request";

@Injectable()
export class ShareService {

    constructor(protected emailComposer: EmailComposer) {

    }

    isAvailable(): Promise<any> {
        return this.emailComposer.isAvailable();
    }

    share(request: BaseRequest): Promise<any> {
        return this.emailComposer.open(request);
    }
}



// WEBPACK FOOTER //
// ./src/vas/services/share/share.service.ts